import { __assign } from "tslib";
export function extendResolversFromInterfaces(schema, resolvers) {
    var typeNames = Object.keys(__assign(__assign({}, schema.getTypeMap()), resolvers));
    var extendedResolvers = {};
    typeNames.forEach(function (typeName) {
        var type = schema.getType(typeName);
        if (type && 'getInterfaces' in type) {
            var allInterfaceResolvers = type
                .getInterfaces()
                .map(function (iFace) { return resolvers[iFace.name]; })
                .filter(function (interfaceResolvers) { return interfaceResolvers != null; });
            extendedResolvers[typeName] = {};
            allInterfaceResolvers.forEach(function (interfaceResolvers) {
                Object.keys(interfaceResolvers).forEach(function (fieldName) {
                    if (fieldName === '__isTypeOf' || !fieldName.startsWith('__')) {
                        extendedResolvers[typeName][fieldName] = interfaceResolvers[fieldName];
                    }
                });
            });
            var typeResolvers = resolvers[typeName];
            extendedResolvers[typeName] = __assign(__assign({}, extendedResolvers[typeName]), typeResolvers);
        }
        else {
            var typeResolvers = resolvers[typeName];
            if (typeResolvers != null) {
                extendedResolvers[typeName] = typeResolvers;
            }
        }
    });
    return extendedResolvers;
}
//# sourceMappingURL=extendResolversFromInterfaces.js.map